/*global kakao*/
import React from "react";
const { kakao } = window;

class KaKaoMap extends React.Component {
  constructor(props) {
    super(props);
  }

  map;
  markers = [];
  infowindows = [];

  componentDidMount() {
    var container = document.getElementById("myMap"); //지도를 담을 영역의 DOM 레퍼런스
    var options = {
      //지도를 생성할 때 필요한 기본 옵션
      center: new kakao.maps.LatLng(this.props.offsetX, this.props.offsetY), //지도의 중심좌표.
      level: 4, //지도의 레벨(확대, 축소 정도)
    };
    this.map = new kakao.maps.Map(container, options); //지도 생성 및 객체 리턴

    var markerPosition = new kakao.maps.LatLng(
      this.props.offsetX,
      this.props.offsetY
    );

    var marker = new kakao.maps.Marker({
      position: markerPosition,
    });

    marker.setMap(this.map);
  }

  render() {
    return (
      <div className="popup">
        <div id="myMap" style={{ width: "100%", height: "100vw" }} />
      </div>
    );
  }
}
export default KaKaoMap;
